import {
    GET_DELIVERY_CAN_TRANSACTIONS,
    GET_DELIVERY_CAN_TRANSACTION,
    DELIVERY_CAN_TRANSACTION_LOADING,
    DELIVERY_CAN_TRANSACTION_ERROR,
    UPDATE_DELIVERY_CAN_TRANSACTION,
    CLEAR_DELIVERY_CAN_TRANSACTIONS
} from '../actions/types';

const initialState = {
    transactions: undefined,
    transaction: null,
    loading: false,
    error: null,
    pages: 0,
    activePage: 1,
    totalCount: 0,
    pageList: []
};

export default function deliveryCanTransactionReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DELIVERY_CAN_TRANSACTION_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case GET_DELIVERY_CAN_TRANSACTIONS:
            return {
                ...state,
                loading: false,
                error: null,
                transactions: payload.transactions || [],
                pages: payload.pages || 0,
                activePage: payload.currentPage || 1,
                totalCount: payload.count || 0,
                pageList: generatePageList(payload.pages || 0)
            };
        
        case GET_DELIVERY_CAN_TRANSACTION:
            return {
                ...state,
                loading: false,
                error: null,
                transaction: payload
            };
        
        case UPDATE_DELIVERY_CAN_TRANSACTION:
            return {
                ...state,
                loading: false,
                error: null,
                transaction: state.transaction && state.transaction._id === payload._id ? payload : state.transaction,
                transactions: state.transactions.map(transaction =>
                    transaction._id === payload._id ? payload : transaction
                )
            };
        
        case DELIVERY_CAN_TRANSACTION_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
                transaction: null
            };
        
        case CLEAR_DELIVERY_CAN_TRANSACTIONS:
            return {
                ...initialState
            };
        
        default:
            return state;
    }
}

/**
 * Helper function to generate page list for pagination
 * @param {number} totalPages - Total number of pages
 * @returns {Array} Array of page numbers
 */
const generatePageList = (totalPages) => {
    if (totalPages <= 1) return [];
    
    const pageList = [];
    for (let i = 1; i <= totalPages; i++) {
        pageList.push(i);
    }
    return pageList;
};
